import React from 'react'
import { useTranslation } from 'react-i18next'
import Slider from 'react-slick'
import { Col, Row } from 'reactstrap'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import AmbientLogo from '../../../public/assets/images/brands/ambient.svg'
import BoseLogo from '../../../public/assets/images/brands/bose.png'
import CinnabonLogo from '../../../public/assets/images/brands/cinnabon.png'
import InvisalignLogo from '../../../public/assets/images/brands/invisalign.png'
import MitsubishiLogo from '../../../public/assets/images/brands/mitsubishi.png'

const ReviewGrid = () => {
  const { t, i18n } = useTranslation()

  const reviews = [
    {
      name: 'MioBebePhotography',
      platform: t('Wix'),
      title: t('Spin to win is amazing'),
      review: t(
        "Our list growth tripled, We're totally blown away with our results. Especially the gamification was..."
      ),
      photo: false
    },
    {
      name: 'Porcelain Art',
      platform: t('Woocommerce'),
      title: t('Shocked'),
      review: t(
        'This app has been incredible value for money. Shocked by the features vs price.'
      ),
      photo: false
    },
    {
      name: 'Ambient Lounge Japan',
      platform: t('Wordpress'),
      title: t('Conversions boosted'),
      review: t("Conversion rate is up 30% , we couldn't be happier!"),
      photo: false
    },
    {
      name: 'Iamyaminah',
      platform: t('Wix'),
      review: t(
        '..This has helped us capture what we need if a customer is about to exit the page.'
      ),
      photo: false
    },
    {
      name: 'Cyberguysdmv',
      platform: t('Wix'),
      title: t('Great app / tool'),
      review: t(
        'Really adds FOMO to the customer experience and helps to build your customer db'
      ),
      photo: false
    },
    {
      name: 'Movxadmin',
      platform: t('Wix'),
      title: t('Great'),
      review: t('Great App. The options are amazing thank you'),
      photo: false
    },
    {
      name: 'Jalecfinancial',
      platform: t('Wix'),
      title: t('So Far So Great'),
      review: t(
        'So Far this app works flawlessly and does exactly what I was looking for.'
      ),
      photo: false
    },
    {
      name: 'Pjvanren',
      platform: t('Wix'),
      title: t('Excellent customer support, problems solved'),
      review: t(
        'Generally worked very well, but I ran into some problems. Customer support solved my problems friendly and helpfully.'
      ),
      photo: false
    },
    {
      name: 'Basvet',
      platform: t('Wix'),
      title: t('Excelente'),
      review: t(
        'La única con pop-ups responsivos, con una interfaz de diseño y configuración sencilla e intuitiva. Gracias!'
      ),
      photo: false
    },
    {
      name: 'Enjosg',
      platform: t('Wordpress'),
      title: t('Great Customer Support'),
      review: t(
        'Thank you for listening to our feedbacks. Great customer support and very helpful.'
      ),
      photo: false
    },
    {
      name: 'Chezl2',
      platform: t('Wix'),
      title: t('géniale'),
      review: t('super simple à utiliser créations illimitées !'),
      photo: false
    },
    {
      name: 'Eemcscquared',
      platform: t('Wix'),
      title: t('わかりやすい'),
      review: t(
        'Privyよりシンプルで日本語対応しているので使いやすいと思いました。'
      ),
      photo: false
    },
    {
      name: 'MrShehroz',
      platform: t('Shopify'),
      review: t(
        'Unlimited auto-responders! Five stars just for that, i have been using it for a bit too long and it works perfect'
      ),
      photo: false
    },
    {
      name: 'Touseef',
      platform: t('Shopify'),
      review: t(
        '試用版の代わりに無料プランがあります。そんなに使っても大丈夫ですか？おおよそのアクセス数がわかっている場合は、最初から計画を決めることができます。将来的にはクーポンルーレットがメジャーになるのではないかと思います。最高でいてくれてありがとう'
      ),
      photo: false
    },
    {
      name: 'CastenCatch',
      platform: t('Shopify'),
      review: t(
        'A/B testing is a game changer for us. We are getting the info we need without breaking our page in Google optimize.'
      ),
      photo: false
    },
    {
      name: 'The House Theory',
      platform: t('Shopify'),
      review: t(
        'Converting well, thanks. Plus the app have a lot of useful features, that had affected on the overall productivity and efficiency in giving the best customer experience on my store. All thanks to these developers'
      ),
      photo: false
    },
    {
      name: 'Daniyal',
      platform: t('Shopify'),
      review: t(
        "Consistently performs ~10% better than the other tools we've tried. It's probably a combination of lots of small things like email correction, faster load times, and being true responsive. Worth the price for sure."
      ),
      photo: false
    },
    {
      name: 'Shoecloset.pk',
      platform: t('Shopify'),
      review: t(
        "I love Promolayer because I don't have to mess with design. I just add components and it's responsive already."
      ),
      photo: false
    },
    {
      name: 'Shopatbasic',
      platform: t('Shopify'),
      review: t(
        'ポップアップやバーを使ってコンバージョンを伸ばすため、こちらのアプリで設計しています。\n' +
          'とにかく表示のタイミングやページの設定など細かく設定ができ、既存顧客へのアップセルやクロスセルにも使えそう。これはうまく設計できれば本当にダイレクトに売上につながりそうだなと思いました。頑張ります！'
      ),
      photo: false
    },
    {
      name: 'STRCH',
      platform: t('Shopify'),
      review: t(
        "I was paying Privy $300 a month for my contact list It's now unlimited on Promolayer for less than half the price...."
      ),
      photo: false
    },
    {
      name: 'Whatavitamin',
      platform: t('Shopify'),
      review: t(
        "The app is being constantly improved. I spoke to Anthony about my needs regarding popup sizes and the team added a new popup resizing feature just for me. I couldn't believe it!"
      ),
      photo: false
    },
    {
      name: 'Skincandy',
      platform: t('Shopify'),
      review: t(
        '海外のアプリをいくつか使いましたが、やはり使い勝手とサポートに不安が残り、こちらのアプリを使ってみました。無料プランだったのですが、サポートの方にご対応いただきポップアップの作成から、自動返信メールの設定まですることができました。これからもよろしくお願いします。'
      ),
      photo: false
    },
    {
      name: 'Michelles Fishing',
      platform: t('Shopify'),
      review: t(
        "Absolutely Amazing App! I'm just loving it! Great results as advertised. Amazing app with amazing features"
      ),
      photo: false
    },
    {
      name: 'kübell',
      platform: t('Shopify'),
      review: t(
        'とても使いやすいですし、無料から始められるのでありがたいです。有料化が必要なレベルの訪問があるのであれば有料でも十分ペイできるはずです。他のメールアプリとの連携もできるので全体像を踏まえ構築したほうが良いです。'
      ),
      photo: false
    }
  ]

  const carouselItems = reviews.map((review, index) => {
    return (
      <div
        className="reviewSlide p-4 rounded-medium"
        key={index}
        style={{ backgroundColor: '#fff', color: '#495057' }}
      >
        <div className="star-rating d-block">
          <i className="mdi mdi-star" />
          <i className="mdi mdi-star" />
          <i className="mdi mdi-star" />
          <i className="mdi mdi-star" />
          <i className="mdi mdi-star" />
        </div>
        {review.title && <p className="mb-0 fw-bold">{review.title}</p>}
        {review.review && (
          <p className="reviewText lead">
            <q>{review.review}</q>
          </p>
        )}
        <div className="review-meta d-flex flex-row align-items-center">
          <div className="review-image d-block">
            <i className="mdi mdi-account-circle mdi-24px pe-3 text-muted" />
          </div>
          <div className="review-name d-block text-left">
            <span className="d-block">{review.name}</span>
            <span className="d-block text-muted">{review.platform}</span>
          </div>
        </div>
      </div>
    )
  })

  return (
    <>
      <Row className="text-center pt-4 pb-3" id="reviews">
        <Col>
          <h1 className="headline">
            <strong>{t('Our happy customers')}</strong>
          </h1>
          <h4>{t('Loved by growth hackers globally.')}</h4>
        </Col>
      </Row>
      <Row className="justify-content-around py-4">
        <Col className="logo text-center">
          <img style={{ width: '150px' }} src={BoseLogo.src} />
        </Col>
        <Col className="logo text-center">
          <img style={{ width: '150px' }} src={CinnabonLogo.src} />
        </Col>
        <Col className="logo text-center">
          <img style={{ width: '150px' }} src={InvisalignLogo.src} />
        </Col>
        <Col className="logo text-center">
          <img style={{ width: '80px' }} src={MitsubishiLogo.src} />
        </Col>
        <Col className="logo text-center">
          <AmbientLogo style={{ width: '160px' }} />
        </Col>
      </Row>
      <Row className="align-items-center justify-content-center">
        <Col className="text-center pt-4 pb-3">
          {i18n.language === 'en' ? (
            <>
              Here are some <em>real reviews</em> from <em>real customers.</em>{' '}
              You can see the reviews live on the{' '}
              <a
                href="https://www.wix.com/app-market/promolayer#reviews"
                target="_blank"
              >
                Wix app market <i className="mdi mdi-open-in-new" />
              </a>{' '}
              and{' '}
              <a
                href="https://apps.shopify.com/promolayer#reviews"
                target="_blank"
              >
                Shopify app store <i className="mdi mdi-open-in-new" />.
              </a>
            </>
          ) : (
            <>
              {' '}
              <em>実際のお客さま</em>による<em>レビュー</em>
              はこちらでご覧いただけます。{' '}
              <a
                href="https://www.wix.com/app-market/promolayer#reviews"
                target="_blank"
              >
                Wixアプリマーケット <i className="mdi mdi-open-in-new" />
              </a>
              、{' '}
              <a
                href="https://apps.shopify.com/promolayer#reviews"
                target="_blank"
              >
                Shopifyアプリストア <i className="mdi mdi-open-in-new" />.
              </a>
            </>
          )}
        </Col>
      </Row>
      <div className="review-grid">{carouselItems}</div>
      <style jsx>
        {`
          .review-wrap {
            max-height: 300px;
            color: #ccc;
          }
          .review-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            column-gap: 16px;
            row-gap: 16px;
          }
          .review-grid :global(.reviewSlide) {
            background-color: #fff;
            box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
          }
          .review-grid :global(.reviewSlide .mdi-star) {
            color: orange;
          }
        `}
      </style>
    </>
  )
}
export default ReviewGrid
